import hechterCasual from './HechterCasual.jpeg';

export const hechterCasualImpressions = {
    hechterCasual,
};
